import React from 'react'

const NatureOfSuitCasesRow = ({meta}) => (
    <tr>
        <td>{meta.title}</td>
        <td>{meta.court_code}</td>
        <td className="ir-search-no-wrap"><a href={"/filings/" + meta.case_uuid} target="_blank">{meta.case_no}</a></td>
        <td>{meta.nature_of_suit_code}</td>
        <td>{meta.date_filed}</td>
        <td>{meta.date_closed}</td>
    </tr>
);

export default NatureOfSuitCasesRow



/** WEBPACK FOOTER **
 ** ./src/components/search/results/rows/natureOfSuit/NatureOfSuitCasesRow.js
 **/